<template>
    <div></div>
</template>

<script>
  import orderStep3DefaultBulkPrices from 'src/mixins/orderStep3DefaultBulkPricesComponent';

  export default {
    mixins: [orderStep3DefaultBulkPrices],
  };
</script>